import { Component, ViewContainerRef } from '@angular/core';
import { Http, Headers } from '@angular/http';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Customer } from '../../models/customer/customer-model'
import { CustomerService } from '../../services/customer/customer.service';
import { UtilitiesService } from '../../services/shared/utilities.service';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { RolePermissionService } from '../../services/role/role-permission.service';
import { EnumDropDown } from '../../models/shared/enum-dropdown'
@Component({
    selector: 'app-customer-list',
    templateUrl: './customer-list.component.html',
    styleUrls: ['./customer-list.component.scss']
})
/** customer-list component*/
export class CustomerListComponent {
  public pagenumber: number = 0;
  public rowsPerPage: number = 10;
  public totalRecord: number = 0;
  public showBoundaryLinks: boolean;
  public searchKeyword: string = "";
  public isLoaded: boolean = false;
  public statusFilter: string;
  public statusCustomerFilter: string;
  public customerType: number;
  public customerStatuses: EnumDropDown[];
  public customerList: Customer[];
  //Filter items from grid
  filteredItems: any[];
  public rowsOnPage: number;
  public arrRowsPerPage: number[];
  public isDeleteAllowed: boolean = false;
  public isEditAllowed: boolean = false;
  /** customer-list ctor */
  constructor(private readonly customerService: CustomerService,
    private readonly activatedRoute: ActivatedRoute,
    private readonly utilitiesService: UtilitiesService,
    private readonly toastr: ToastsManager, vcr: ViewContainerRef, private readonly router: Router, private readonly rolePermissionService: RolePermissionService) {
    //this.activatedRoute.params.subscribe((params: Params) => {
    //  this.customerType = params['id'];
    //  this.getcustomers(this.customerType);
    //  this.GetRowsPerPageList();
    //  this.toastr.setRootViewContainerRef(vcr);


    //});
    //customer = true
    //vendor = false
    this.pagenumber = 0;
    this.rowsOnPage = 10;
    this.rowsPerPage = 10;
    this.isLoaded = false;
    this.searchKeyword = "";
    this.statusFilter = "";
    this.showBoundaryLinks = true;
    this.rolePermissionService.GetRolePermissions("customer").subscribe(
      data => {
        if (data != null) {

          var create = data.filter(function (element) {
            return (element.action == "create");
          });
          var list = data.filter(function (element) {
            return (element.action == "list");
          });

          var deletePermission = data.filter(function (element) {
            return (element.action == "delete");
          });

          var edit = data.filter(function (element) {
            return (element.action == "edit");
          });

          if (edit.length > 0)
            this.isEditAllowed = true;

          if (deletePermission.length > 0)
            this.isDeleteAllowed = true;
          if (list.length > 0) {
            this.customerType = 2;
            // this.getcustomers(this.customerType);
            this.OnFilterChange();
          //  this.GetRowsPerPageList();
            this.toastr.setRootViewContainerRef(vcr);
            this.statusFilter = "";
          }
          else {
            this.router.navigate(["/"]);
          }
        }
        else {
          this.router.navigate(["/"]);
        }
      }
    )
  }

  deletecustomer(id) {
    var ans = confirm("Are you sure to delete this customer ?");
    if (ans) {
      this.customerService.deleteCustomer(id).subscribe(result => {
        if (result) {
          this.toastr.success('Customer has been deleted.', 'Success');
          setTimeout(() => {
            this.getcustomers(this.customerType);
          }, 3000);
        }
        else {
          this.toastr.error('Error occurred. Please try again', 'Error');
          }
      });
    }
  }
  UpdateFullName() {
    this.customerService.UpdateCustomerFullName().subscribe(data => {
      if (data) {
        this.toastr.success('Update Successfully', 'Success')
      }else {
          this.toastr.error('Error occurred. Please try again', 'Error');
        }
      });
  }
  getcustomers(customerType : number) {
    this.customerService.getCustomer().subscribe(
      data => {
        this.customerList = data;
        this.filteredItems = data;
        if(customerType == 2)
        {
          this.statusCustomerFilter = "true";
          this.filteredItems = this.filteredItems.filter(c => c.isCustomer == true);
        }
        else{
          this.statusCustomerFilter = "false"
          this.filteredItems = this.filteredItems.filter(c => c.isCustomer == false);
        }
      }
    )
  }
  // Populate the row per page list
  GetRowsPerPageList() {
    this.arrRowsPerPage = this.utilitiesService.GetRowsPerPageList();
    this.rowsOnPage = this.arrRowsPerPage[0];
  }
  exportCustomer() {
    var data = this.customerList
    //this.customerService.exportAsExcelFile(data, "Test");
  }
  toggleStatus(id : string) {

    this.customerService.toggleStatus(id).subscribe(
      data => {
        setTimeout(() => {
          this.getcustomers(this.customerType);
        }, 2000);
      }
    )
  }

  OnFilterChange() {
    this.pagenumber = 0;
    this.OnFilterChangegrid();
  }

  PageChanged($event) {
    this.pagenumber = ($event.page) - 1;
    this.rowsPerPage = $event.itemsPerPage;

    this.OnFilterChangegrid();
  }
  onKeydown(event) {
    if (event.key === "Enter") {
      this.OnFilterChange();
    }
  }
  OnFilterChangegrid() {
    if (this.rowsPerPage == undefined) this.rowsPerPage = 10;
    if (this.pagenumber == undefined) this.pagenumber = 0;
    this.customerService.GetCustomerGrid(this.pagenumber, this.rowsOnPage, this.statusFilter, this.searchKeyword).subscribe(
      data => {
        this.isLoaded = true;
        this.customerList = data;
        if (this.customerList != null && this.customerList.length > 0)
          this.totalRecord = this.customerList[0].totalRecords;
        else
          this.totalRecord = 0;

      }
    )
  }
  // Search the Grid
  onSearch() {

    this.filteredItems = this.customerList;
    var searchText = (document.getElementById("txtSearchCustomer") as HTMLInputElement).value;

    if (searchText != "") {
      this.filteredItems = this.utilitiesService.GetSearchedResult(this.customerList, searchText);

    } else {
      this.filteredItems = this.customerList;
    }

    if (this.statusFilter == "true") {
      this.filteredItems = this.filteredItems.filter(c => c.isActive == true);

    }
    else if (this.statusFilter == "false") {
      this.filteredItems = this.filteredItems.filter(c => c.isActive == false);
    }

    if (this.statusCustomerFilter == "true") {
      this.filteredItems = this.filteredItems.filter(c => c.isCustomer == true);

    } else if (this.statusCustomerFilter == "false") {
      this.filteredItems = this.filteredItems.filter(c => c.isCustomer == false);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/customer-components/customer-list/customer-list.component.ts